var _defs, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFemaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-5.559%",
    y1: "149.269%",
    x2: "69.689%",
    y2: "17.568%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD2E79",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16955",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.932 12.866c0 .459.375.83.837.83a.834.834 0 0 0 .837-.83.834.834 0 0 0-.837-.83.834.834 0 0 0-.837.83Zm6.983 0c0 .459.375.83.837.83a.834.834 0 0 0 .837-.83.834.834 0 0 0-.837-.83.834.834 0 0 0-.837.83Zm6.02-2.503a8.881 8.881 0 0 0-.01-.342l.01-.184c.01-.168-.018-.35-.075-.54-.369-2.837-2.13-5.968-6.225-6.778.052-.17.078-.346.079-.524C11.714.893 10.716 0 9.485 0c-1.23 0-2.228.893-2.228 1.995 0 .18.027.357.08.528-4.568.925-6.275 4.797-6.301 7.862a2.528 2.528 0 0 0 .58 4.4c.919 5.79 1.307 4.226 1.307 3.539 0-.314-.136-1.209-.174-2.297a7.63 7.63 0 0 0 1.319 1.749A7.634 7.634 0 0 0 9.48 20c2.044 0 3.966-.79 5.412-2.224a7.69 7.69 0 0 0 .904-1.08 86.688 86.688 0 0 0-.062 2.1c0 .691.67-.18 1.376-3.12.074-.305.14-.591.2-.863A2.541 2.541 0 0 0 19 12.424a2.53 2.53 0 0 0-1.066-2.061ZM.352 12.424c0-.623.265-1.195.701-1.599.006.05.013.095.021.136.172 1.337.33 2.463.476 3.41a2.186 2.186 0 0 1-1.198-1.947Zm15.47 3.564a7.315 7.315 0 0 1-6.343 3.661 7.312 7.312 0 0 1-6.738-4.454c.034-1.542.344-3.256 1.486-4.233C5.455 9.912 6.053 8.187 6.34 6.86c.267 1.166.876 2.573 2.264 2.895 2.355.547 3.399.574 4.475.592.51.008 2.672-.081 2.89 2.077 0 0-.08 1.841-.147 3.564Zm1.575-1.592c.294-1.421.398-2.39.462-3.306.027-.075.047-.17.06-.289.451.405.727.987.727 1.623 0 .854-.496 1.61-1.249 1.972Z",
    fill: "url(#a)",
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleIcon);
export default __webpack_public_path__ + "static/media/female-icon.0946c4922c6fd94d3b28c8fb9388b7bd.svg";
export { ForwardRef as ReactComponent };